/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSpaceFilled: {
  name: 'space-filled';
  data: string;
} = {
  name: 'space-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.516 8.577a1.707 1.707 0 0 0-.878.803l-.098.2v2c0 1.974.001 2.003.09 2.237a2.673 2.673 0 0 0 1.553 1.553l.237.09h17.16l.237-.09a2.673 2.673 0 0 0 1.553-1.553c.089-.234.09-.263.09-2.237v-2l-.098-.2a1.793 1.793 0 0 0-.711-.723c-.212-.107-.266-.117-.651-.117s-.439.01-.651.117a1.793 1.793 0 0 0-.711.723c-.097.198-.098.211-.118 1.66l-.02 1.46h-15l-.02-1.46c-.02-1.449-.021-1.462-.118-1.66a1.792 1.792 0 0 0-.709-.722c-.198-.1-.282-.117-.611-.126-.253-.007-.431.008-.526.045"/></svg>`
};
